<template>
  <div class="gwave-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$h = ΔL / L$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>应变幅度 h</label>
            <span class="val">10^{-21} (模拟)</span>
          </div>
          <div class="hud-item rose">
             <label>干涉仪状态</label>
             <span class="val">{{ phaseShifted ? '相位移动' : '相消干涉' }}</span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 500 240" preserveAspectRatio="xMidYMid meet">
          <!-- 激光源 -->
          <rect x="20" y="115" width="30" height="10" fill="#f43f5e" />
          
          <!-- 分束镜 -->
          <line x1="120" y1="90" x2="160" y2="150" stroke="#94a3b8" stroke-width="4" />

          <!-- LIGO X臂与Y臂 -->
          <line x1="140" y1="120" :x2="280 + deltaL" y2="120" stroke="#3b82f6" stroke-width="3" opacity="0.8" />
          <line x1="140" y1="120" x2="140" :y2="20 - deltaL" stroke="#06b6d4" stroke-width="3" opacity="0.8" />

          <!-- X/Y 端镜 -->
          <rect :x="280 + deltaL" y="100" width="10" height="40" fill="#64748b" />
          <rect x="120" :y="20 - deltaL - 10" width="40" height="10" fill="#64748b" />

          <!-- 时空网格抖动模拟 -->
          <rect v-if="waveIntensity > 0" x="50" y="50" width="400" height="140" fill="none" stroke="rgba(59, 130, 246, 0.2)" stroke-dasharray="2,2">
             <animate attributeName="stroke-dashoffset" from="0" to="20" dur="0.5s" repeatCount="indefinite" />
          </rect>

          <!-- 探测光电管 (底部) -->
          <rect x="135" y="180" width="10" height="20" fill="#1e293b" />
          <circle v-if="phaseShifted" cx="140" cy="190" r="15" fill="#f43f5e" opacity="0.4">
             <animate attributeName="opacity" values="0.2;0.8;0.2" dur="0.2s" repeatCount="indefinite" />
          </circle>
        </svg>

        <div class="physics-caption">
          <strong>物理规律：</strong>引力波横向传播时会使空间的几何度规发生变化。LIGO 通过超长双臂干涉仪，检测由时空拉伸引起的极微小的<strong v-latex>臂长差异 $\Delta L$</strong>。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="label-row"><span class="label">模拟引力波源强度</span></div>
           <el-slider v-model="waveIntensity" :min="0" :max="10" size="small"></el-slider>
        </div>
        
        <div class="discovery-card-discovery" v-latex>
           <i class="el-icon-odometer"></i>
           <p><strong>实战物理：</strong>2015年首次探测到的信号仅为质子直径的千分之一。<strong>观察：</strong>随着你滑块增加波强（由黑洞合并产生），干涉仪的两条蓝/青色臂会交替发生伸缩。这种<strong>时空形变</strong>打破了光的完全相消平衡。
           </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'GravitationalWaveViz',
  data() {
    return {
      waveIntensity: 3.5,
      t: 0,
      deltaL: 0
    }
  },
  computed: {
    phaseShifted() { return this.waveIntensity > 0.5; }
  },
  mounted() {
    this.animate();
  },
  methods: {
    animate() {
       requestAnimationFrame(this.animate);
       this.t += 0.1;
       this.deltaL = Math.sin(this.t) * (this.waveIntensity * 2);
    }
  },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.gwave-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
